import { render, staticRenderFns } from "./hospitallist.vue?vue&type=template&id=0ecbd456&"
import script from "./hospitallist.vue?vue&type=script&lang=js&"
export * from "./hospitallist.vue?vue&type=script&lang=js&"
import style0 from "./hospitallist.vue?vue&type=style&index=0&id=0ecbd456&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports